import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { PerfilService } from 'src/app/services/perfil.service';
import { TarjetaService } from 'src/app/services/tarjeta.service';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-clients',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CdkScrollable,
    MatButtonModule,
    MatTooltipModule,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    TablerIconsModule,
    NgxSpinnerModule,
    MatPaginator,
    MatIconModule,
    MatTabsModule,
    MatTableModule
  ],
  templateUrl: './admin-clients.component.html',
  styleUrl: './admin-clients.component.scss'
})
export class AdminClientsComponent implements OnInit {

  displayedColumnsPerfiles: string[] = ['nombre', 'acciones'];
  perfiles: MatTableDataSource<any>;

  displayedColumnsTarjetas: string[] = ['nombre', 'acciones'];
  tarjetas: MatTableDataSource<any>;
  displayedColumnsFichaMotor: string[] = ['patente', 'nombre', 'correo', 'fechaCreacion', 'acciones'];
  fichaMotorTarjetas: MatTableDataSource<any>;
  pageIndex: number;
  length: number;
  fichaMotorPageIndex: number;
  fichaMotorLength: number;
  palabraClave: string = '';
  palabraClaveFichaMotor: string = '';

  idCliente: string | null = '';
  isTempClient = false; // Para clientes temporales (cliente 234)

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private perfilService: PerfilService,
    private tarjetaService: TarjetaService,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.idCliente = params.get('id');
      const userProfile = this.authService.getProfileFromToken();
      // Bloquear si es perfil TEMP_CLIENT (4)
      this.isTempClient = userProfile === 4;

      // Los clientes temporales no deben acceder a esta página
      if (this.isTempClient) {
        this.snackBar.open('Acceso restringido para clientes temporales', 'Cerrar', { duration: 3000 });
        this.router.navigate(['/authentication/login']);
        return;
      }

      this.getDataPerfil();
      this.callData();
      this.callFichaMotorData();
    });

  }



  getDataPerfil() {
    this.perfilService.getPerfiles(this.idCliente).subscribe({
      next: (response) => {
        this.perfiles = new MatTableDataSource(response);
      },
      error: (err) => {
        console.error('Error al cargar los Perfiles:', err);
      },
    });
  }

  public getServerData(event: PageEvent) {
    this.callData(event);
  }

  public callData(event?: PageEvent): void {
    const pageNum = event ? event.pageIndex + 1 : 1;
    const pageSize = event?.pageSize || 12;
    this.tarjetaService.getTarjetasByTipo(this.idCliente, pageNum, pageSize, this.palabraClave, undefined, 3).subscribe({
      next: (response) => {
        this.pageIndex = response.pageNum - 1;
        this.length = response.total;
        this.tarjetas = new MatTableDataSource(response.list || []);
      },
      error: (err) => {
        console.error('Error al cargar los talleres:', err);
      },
    });
  }

  public getFichaMotorServerData(event: PageEvent) {
    this.callFichaMotorData(event);
  }

  public callFichaMotorData(event?: PageEvent): void {
    const pageNum = event ? event.pageIndex + 1 : 1;
    const pageSize = event?.pageSize || 12;
    this.tarjetaService.getTarjetasByTipo(this.idCliente, pageNum, pageSize, this.palabraClaveFichaMotor, 3).subscribe({
      next: (response) => {
        this.fichaMotorPageIndex = response.pageNum - 1;
        this.fichaMotorLength = response.total;
        this.fichaMotorTarjetas = new MatTableDataSource(response.list || []);
      },
      error: (err) => {
        console.error('Error al cargar fichas motor:', err);
      },
    });
  }


  agregarTarjeta(): void {
    this.router.navigate(['/admin-client', this.idCliente, 'card', 0]);
  }

  editarTarjeta(jarjeta: any): void {
    this.router.navigate(['/admin-client', this.idCliente, 'card', jarjeta.id]);
  }

  agregarFichaMotor(): void {
    this.router.navigate(['/admin-client', this.idCliente, 'ficha-motor', 0]);
  }

  editarFichaMotor(tarjeta: any): void {
    this.router.navigate(['/admin-client', this.idCliente, 'ficha-motor', tarjeta.id]);
  }

  eliminarTarjeta(id: number): void {
    Swal.fire({
      title: "Está seguro?",
      text: "La Tarjeta quedará eliminada para siempre!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, Borrar!",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.tarjetaService.deleteTarjeta(id).subscribe({
          next: (data) => {
            this.spinner.hide();
            this.callData();
            this.callFichaMotorData();
            this.snackBar.open(data.msg, 'Cerrar', { duration: 3000 });
          },
          error: (err) => {
            this.spinner.hide();
            console.error('Error al eliminar la Tarjeta:', err);
            this.snackBar.open('Hubo un error al eliminar la Tarjeta.', 'Cerrar', { duration: 3000 });
          },
        });
      }
    });
  }


  agregarPerfil(): void {
    this.router.navigate(['/admin-client', this.idCliente, 'profile', 0]);
  }

  editarPerfil(perfil: any): void {
    this.router.navigate(['/admin-client', this.idCliente, 'profile', perfil.id]);
  }

  eliminarPerfil(id: number): void {
    Swal.fire({
      title: "Está seguro?",
      text: "El Perfil será eliminado y las tarjetas asociadas quedarán sin perfil!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, Borrar!",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.perfilService.deletePerfil(id).subscribe({
          next: (data) => {
            this.spinner.hide();
            this.getDataPerfil();
            this.snackBar.open(data.msg, 'Cerrar', { duration: 3000 });
          },
          error: (err) => {
            this.spinner.hide();
            console.error('Error al eliminar el Perfil:', err);
            this.snackBar.open('Hubo un error al eliminar el Perfil.', 'Cerrar', { duration: 3000 });
          },
        });
      }
    });
  }

  volver(): void {
    this.router.navigate(['/admin/stores']);
  }

}
